(function ($, Drupal) {

  /** Temp solution for isa login **/
  function loginLink(context) {
    $('body .usermenu-list a[href="user/login"]', context).attr("href", "user/login");
  }

  /**
   * Header search click
   */
  function headerSearch(context) {
    var $searchBlock = $("body .search-block", context);
    var $searchIcn = $searchBlock.find(".search-icn");

    $searchIcn.on('click', function () {
      $searchBlock.toggleClass('show');
      $searchBlock.find('input[name="search_api_fulltext"]').focus();
      $(this).toggleClass('close-iz');
    });

    $(document, context).mouseup(function (e) {
      var container = $searchBlock;
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('show');
        $searchBlock.find(".search-icn").removeClass('close-iz');
      }
    });
  }

  /**
   * Header Toggle Click
   */
  function headerToggle(context) {
    $("body header .navbar-toggle", context).click(function () {
      $(this).toggleClass("active");
      $("body").toggleClass("menu-expanded");
      $("body header.navigation #isa-header-text .menu").removeClass("show-menu");
    });
  }

  /**
   * Open mega menu
   */
  function openMegaMenu(context) {
    $("body #site-header #onctop .onctopheader .block-menu>.menu>li:has(ul)", context).on("click", function () {
      $(this).toggleClass("mega-menu-expand");
    });
  }

  /**
   * Close mega menu
   */
  function closeMegamenu(context) {
    $("body #site-header #onctop .onctopheader .block-menu > .menu > li > .menu", context).append('<a class="close">CLOSE</a>');

    var $userImg = $("body .user-details-block .views-field-user-picture .field-content", context);
    if ($userImg.find("img").length == 0)
      $userImg.append('<img src="/themes/custom/isa/images/header/user_default.jpg" class="image-style-thumbnail">');

    if ($(window).width() > 991) {
      $(document).mouseup(function (e) {
        var container = $("body #site-header #onctop .onctopheader .block-menu > .menu > li:has(ul)");

        if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.removeClass("mega-menu-expand");
        }
      });
    }
  }

  /**
   * submenu in mega menu
  */
  var submenuInitialized = false;
  function submenuToggle(context) {
    if (submenuInitialized) {
      return; // Exit if the function has already been executed
    }

    submenuInitialized = true; // Set the flag to true
    var $menuItems = $("body #site-header #onctop .onctopheader .block-menu>.menu>li>.menu>li .menu li");

    // Add 'hasSubmenu' class to items that have a submenu
    $menuItems.each(function () {
      var hasSubmenu = $(this).find('ul.menu').length > 0;
      if (hasSubmenu) {
        $(this).addClass("hasSubmenu");
      }
    });

    // Handle toggle logic
    $menuItems.find('span').on("click", function (event) {
      event.stopPropagation(); // Prevent event bubbling
      var $currentMenuItem = $(this).closest('li');

      // Remove 'show-sub-menus' class from other <li> elements
      $menuItems.not($currentMenuItem).removeClass("show-sub-menus");

      // Toggle 'show-sub-menus' class on the clicked item
      $currentMenuItem.toggleClass("show-sub-menus");
    });
  }


  /**
   * Add home and back button on responsive header
   */
  function responsiveHeader(context) {
    if ($(window).width() < 992) {
      var $blockMenu = $("body #site-header #onctop .onctopheader .block-menu", context);
      if (!$blockMenu.find(".home").length) {
        $blockMenu.find("> .menu > li:first-child ").before('<li class="home"><a href="/">Home</a></li>');
      }

      $blockMenu.find(".menu > li:has(.menu) > span, .menu > li:has(.menu) > a", context).on("click", function (e) {
        e.preventDefault();
        $(this).next(".menu").addClass("show-menu");
      });

      if (!$blockMenu.find(".back").length) {
        $blockMenu.find(">.menu .menu li:first-child").before("<li class='back'><a>Back</a></li>");
      }

      $blockMenu.on("click", ".back", function (e) {
        e.preventDefault();
        $(this).closest(".menu").removeClass("show-menu");
      });

      var $menuLinkLists = $("body #site-header #onctop .onctopheader .block-menu>.menu>li>.menu>li:has(.menu)");
      $menuLinkLists.each(function () {
        var menuLink = $(this).find('> a').clone();
        if ($(this).find('.prev-main-menu').length == 0) {
          $(this).find('> ul.menu >li.back').after(`<li class="prev-main-menu"></li>`);
          $(this).find('> ul.menu > .prev-main-menu').append(menuLink);
        }
      });
    }
  }

  /**
   * Show user menu list by clicking on user icon
   */
  function userMenuList(context) {
    var $userMenu = $("body.user-logged-in #isa-header-text .user-details-block", context);

    $userMenu.find(".views-field-user-picture", context).on("click", function () {
      $(this).toggleClass("open");
      $userMenu.find(".usermenu").toggleClass("show");
    });

    $(document, context).mouseup(function (e) {
      var container = $userMenu;
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $userMenu.find(".usermenu").removeClass("show");
        $userMenu.find(".views-field-user-picture").removeClass("open");
      }
    });

    $userName = $userMenu.find(".views-field-name .field-content >a").clone();
    $userMenu.find(".usermenu .usermenu-list").prepend($userName);
  }

  // Function to set active menu item
  function setActiveMenu(context) {
    var path = window.location.pathname;
    $('.navigation .block-menu .menu li a', context).each(function () {
      var href = $(this).attr('href');
      var elmCount = $('.navigation .block-menu .menu li a[href="' + href + '"]').length;
      if (path === href) {
        if (elmCount > 1) {
          $('body:not(.path-frontpage) header.navigation .block-menu>ul>li.menu-item > a[href="' + href + '"]').addClass('menu-is-active');
        }
        else {
          $(this).addClass('menu-is-active');
        }

      } else {
        $(this).removeClass('menu-is-active');
      }
    });
  }

  // open external links in new tab
  function openExternal(context) {
    $('header .menu a[href^="http"],.benner_right_item-wrap a[href^="http"]', context).attr('target', '_blank');
  }


  //temp function for check popup

  function check(context) {

    $('[data-drupal-selector="edit-uscdi-fieldset"] .form-type-select select[data-once="chosen"]', context).once('myCustomBehavior').change(function () {
      var selectedValue = $(this).val();
      $('#nextInput').val(selectedValue);
    });
    $('body').on("change", '[data-drupal-selector="edit-uscdi-fieldset"] .form-type-select select[data-once="chosen"]', function () {
      alert("change");
      var selectedValue = 901;
      console.log(selectedValue);
      $(this).closest('.js-form-item').next("div").find("select").append('<option>' + selectedValue + '</option>').addClass("akhil");
      //$('#nextInput').val(selectedValue);
    });
  }


  Drupal.behaviors.customHeaderBehaviors = {
    attach: function (context, settings) {
      //loginLink(context);
      headerSearch(context);
      headerToggle(context);
      openMegaMenu(context);
      closeMegamenu(context);
      responsiveHeader(context);
      userMenuList(context);
      setActiveMenu(context);
      openExternal(context);
      submenuToggle(context);
      //openSubMenuItem(context);
      //check(context);
      $(window).on("resize", function () {
        responsiveHeader(context);
      });
    }
  };

})(jQuery, Drupal);



